"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalEnv = exports.getMicrosEnv = exports.getEnvironment = exports.ENVIRONMENT = exports.NODE_ENV = exports.MICROS_ENV = void 0;
const environment_constants_1 = require("./environment-constants");
exports.MICROS_ENV = String(process.env.MICROS_ENV);
exports.NODE_ENV = String(process.env.NODE_ENV);
exports.ENVIRONMENT = process.env.ENVIRONMENT;
// Determining the environment using the hostname
const getEnvironment = () => {
    const hostName = window.location.hostname;
    if (hostName.includes('.dev.')) {
        return environment_constants_1.DEVELOPMENT;
    }
    else if (hostName.includes('.staging.') || hostName.includes('.stg.')) {
        return environment_constants_1.STAGING;
    }
    else if (hostName.includes('.prod.') ||
        hostName.includes('ppc.atlassian') ||
        hostName.includes('admin.atlassian') ||
        hostName.includes('advocate-central.atlassian')) {
        return environment_constants_1.PRODUCTION;
    }
    else if (hostName.includes('localhost')) {
        return environment_constants_1.LOCAL;
    }
    else {
        return environment_constants_1.STAGING;
    }
};
exports.getEnvironment = getEnvironment;
const getMicrosEnv = () => {
    return exports.MICROS_ENV;
};
exports.getMicrosEnv = getMicrosEnv;
const isLocalEnv = () => {
    return exports.NODE_ENV === 'local';
};
exports.isLocalEnv = isLocalEnv;
